<template>
	<div style="background-color: #DFECFF;">
		<BaseNav></BaseNav>
		<div class="bg"></div>
		<div class="content">
			<div class="title-box">
				<img src="@/assets/boss/item_icon.jpg" alt="">
				<div class="title">项目介绍</div>
			</div>
			<div class="news">
				<div class="news-content">
					<p>疫情发生以来，对各行各业都造成很大影响，同时国内经济运行压力加大等不利因素，包括我所挂牌企业在内的全省中小微企业都面临较大的经营压力。</p>
					<p>雄安股交作为我省唯一一家区域性股权市场运营机构，为帮助我省实体经济尤其中小微企业走出困局，创新服务模式，搭建了为企业拓展业务资源的平台-“河北省中小企业孵化服务中心”。雄安股交所坚决落实省委省政府的决策，围绕河北省优质中小微企业集聚地”和“企业上市孵化基地”的战略定位，坚持服务实体经济、坚持服务中小微企业。通过组建平等、互助的业务对接平台，拓宽企业销售渠道，助力企业持续健康发展，为新时代全面建设现代化经
						济强省、美丽河北作出新的贡献！</p>
					<p style="text-align: right;">项目启动仪式-----></p>
				</div>
				<div class="banner">
					<a-carousel autoplay>
						<div v-for="(item,index) in bannerList" :key="index"><img
								style="width: 600px;height: 344px;object-fit: cover;" :src="filePath+item.imageUrl"
								alt=""></div>
					</a-carousel>
				</div>
			</div>
			<div class="idea">
				<div class="title">宗旨理念</div>
				<div class="sub_title">商机共享 以德谋财</div>
				<div class="idea-item">
					<div class="item">
						<img src="@/assets/boss/grid_icon_1.png" alt="">
						<div class="margin-top-15">
							<div class="item-title">资本服务</div>
							<div class="item-desc">依托交易所为企业在挂牌、融资、股改、路演等方面提供专业服务设计关于营销、路演、法律、管理等课程提升企业家管理能力。</div>
						</div>
					</div>
					<div class="item">
						<img src="@/assets/boss/grid_icon_2.png" alt="">
						<div class="margin-top-15">
							<div class="item-title">资源支持</div>
							<div class="item-desc">每周定期组织早餐会，多见面多交流，增加业务</div>
						</div>
					</div>
					<div class="item">
						<img src="@/assets/boss/grid_icon_3.png" alt="">
						<div class="margin-top-15">
							<div class="item-title">先舍后得</div>
							<div class="item-desc">我们尊崇先舍后得的精神，学会付出，必然有收获。</div>
						</div>
					</div>
					<div class="item">
						<img src="@/assets/boss/grid_icon_4.png" alt="">
						<div class="margin-top-15">
							<div class="item-title">宣传推广</div>
							<div class="item-desc">对学员项目，将在学员圈、官网及其他媒体上广泛宣传，同时在后期受到跟踪报道和项目宣传。</div>
						</div>
					</div>
				</div>
			</div>
			<div class="data-box">
				<div class="item">
					<div class="number">{{bossData.intention}}</div>
					<div class="title">推介意向（个）</div>
					<img class="margin-top-15" width="30" src="@/assets/boss/light_icon.png" alt="">
				</div>
				<div class="item">
					<div class="number">{{bossData.student}}</div>
					<div class="title">优秀学员（名）</div>
					<img class="margin-top-15" width="30" src="@/assets/boss/person.png" alt="">
				</div>
				<div class="item">
					<div class="number">{{bossData.turnover}}</div>
					<div class="title">推介成交额（万元）</div>
					<img class="margin-top-15" width="30" src="@/assets/boss/money.png" alt="">
				</div>
				<div class="item">
					<div class="number">{{bossData.breakfast}}</div>
					<div class="title">早餐会（次）</div>
					<img class="margin-top-15" width="30" src="@/assets/boss/house.png" alt="">
				</div>
			</div>
			<div class="fengcai">
				<div class="title">学员风采</div>
				<div class="control">
					<div class="tabs">
						<div class="tab" :class="currentAddress.id == item.id?'active':''"
							v-for="(item,index) in addressList" @click="changeAddress(item)">{{item.studentAddress}}
						</div>
					</div>
					<div class="change">
						<button class="prev" @click="prev">
							< </button>
								<button class="next" @click="next"> > </button>
					</div>
				</div>
				<div class="list">
					<div class="item" v-for="(item,index) in studentList.records" :key="index"
						@click="chooseStudent(item)">
						<img class="thumb" :src="filePath + item.bacImage" alt="">
						<div class="color-mask" :class="'mask-'+index">
							<div class="name">{{item.companyName}}</div>
							<div class="desc">{{item.content}}</div>
							<div class="position">{{item.position}}&nbsp;&nbsp;-&nbsp;&nbsp;{{item.name}}</div>
						</div>
					</div>
				</div>
			</div>
			<!--  -->


			<!-- 往期早餐会展示 -->
			<div class="meeting">
				<div class="title">早餐会 · 一对一拜访</div>
				<div class="sub_title">深度交流，资源共享</div>
				<div v-if="showMeeting">
					<a-carousel autoplay arrows :dots="false">
						<template #prevArrow>
							<div class="custom-slick-arrow" style="left: 10px; z-index: 1">
								<img src="@/assets/arrow-left-bold.png" alt="">
							</div>
						</template>
						<template #nextArrow>
							<div class="custom-slick-arrow" style="right: 50px">
								<img src="@/assets/arrow-right-bold.png" alt="">
							</div>
						</template>
						<div class="box" v-for="(item,index) in meetingList" :key="index">
							<div class="flex">
								<div class="item" @click="chooseMeet(child)" v-for="(child,childIndex) in item"
									:key="childIndex"
									:style="`background: url(${filePath+child.imageUrl}) no-repeat;backgroundSize:cover;`">
									<button class="info_btn">查看详情</button>
								</div>
							</div>
						</div>
					</a-carousel>
				</div>
			</div>
			<div style="clear: both;"></div>
		</div>
		<div class="apply" @click="showApplyModal = true">
			<div>在线</div>
			<div>报名</div>
		</div>
		<div v-if="showModal">
			<PhotoView @close="closeModal" :showControl="true" :list="currentBanner"></PhotoView>
		</div>
		<div v-if="showStudentModal">
			<PhotoViewStudent @close="closeStudentModal" :showControl="false" :list="currentStudentImg">
			</PhotoViewStudent>
		</div>
		<a-modal v-model:visible="showApplyModal" title="在线报名" @ok="handleOk" cancelText="取消" okText="报名" centered>
			<a-form style="padding:20px;" :model="formState" name="basic" autocomplete="off" @finish="onFinish"
				@finishFailed="onFinishFailed">
				<a-form-item label="">
					<a-input v-model:value="form.name" placeholder="请输入姓名" />
				</a-form-item>
				<a-form-item label="">
					<a-input v-model:value="form.companyName" placeholder="请输入公司名称" />
				</a-form-item>
				<a-form-item label="">
					<a-input v-model:value="form.phone" placeholder="请输入手机号" />
				</a-form-item>
				<a-form-item label="">
					<div class="flex">
						<a-input v-model:value="form.smsCode" placeholder="请输入验证码" />
						<a-button type="primary" @click="sendMsg" :disabled="btnDisabled">{{tips}}</a-button>
					</div>
				</a-form-item>
			</a-form>
			<Vcode :show="isShow" @success="vcodeSuccess" @close="close" />
		</a-modal>
		<BaseFooter></BaseFooter>
	</div>
</template>

<script>
	import BaseNav from "@/components/BaseNavigation"
	import BaseFooter from "@/components/BaseFooter"
	import vueSeamlessScroll from 'vue-seamless-scroll'
	import PhotoView from "@/components/photo/PhotoView"
	import PhotoViewStudent from "@/components/photo/PhotoViewStudent"
	import Vcode from "vue-puzzle-vcode";

	export default {
		components: {
			BaseNav,
			BaseFooter,
			vueSeamlessScroll,
			PhotoView,
			PhotoViewStudent,
			Vcode
		},
		data() {
			return {
				bossData: {},
				bannerList: [],
				showMeeting: false,
				visible: false,
				filePath: this.$api.filePath,
				meetingList: [],
				currentMeeting: {},
				currentBanner: [],
				width: {},
				showModal: false,
				currentAddress: {},
				addressList: [],
				currentStudent: {},
				studentList: [],
				currentStudentImg: [],
				studentPage: 1,
				showStudentModal: false,
				showApplyModal: false,
				tips: "发送验证码",
				btnDisabled: false,
				isShow:false,
				form: {
					name: "",
					companyName: "",
					phone: "",
					smsCode: "",
				}
			}
		},
		computed: {
			seamlessScrollOption() {
				return {
					step: 0.7, // 数值越大速度滚动越快
					limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 2, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
				};
			}
		},
		mounted() {
			document.title = "雄安股权交易所-河北省企业资源共享服务中心";
			this.queryBossData();
			this.queryBossBannerList();
			this.queryMettingList();
			this.quryAddressList();
		},
		methods: {
			close(){

			},
			handleOk() {
				console.log(this.form);
				if (this.form.name == "") {
					this.$message.error("请输入姓名");
					return false;
				}
				if (this.form.companyName == "") {
					this.$message.error("请输入公司名称");
					return false;
				}
				if (this.form.phone == "") {
					this.$message.error("请输入电话");
					return false;
				}
				if (!(/^1[3456789]\d{9}$/.test(this.form.phone))) {
					this.$message.error("请输入正确的手机号");
					return false;
				}
				if (this.form.smsCode == "") {
					this.$message.error("请输入验证码");
					return false;
				}
				this.$request({
					url: this.$api.boss.signUp,
					method: "post",
					data: this.form
				}).then((res) => {
					if (res.data.success) {
						this.$message.success("报名成功");
						this.showApplyModal = false;
					} else {
						this.$message.error(res.data.message);
					}
				})
			},
			vcodeSuccess(){
				this.isShow = false;
				let time = 60;
				let that = this;
				if (!(/^1[3456789]\d{9}$/.test(this.form.phone))) {
					this.$message.error("请输入正确的手机号");
					return false;
				}
				this.sendPhone();
				this.btnDisabled = true;
				that.tips = time + "S后再次发送";
				var timer = setInterval(() => {
					if (time > 1) {
						time--;
						that.tips = time + "S后再次发送";
					} else {
						time = 60;
						that.tips = "发送验证码";
						clearInterval(timer);
						that.btnDisabled = false;
					}
				}, 1000);
			},
			//发送验证码
			sendMsg() {
				if (!(/^1[3456789]\d{9}$/.test(this.form.phone))) {
					this.$message.error("请输入正确的手机号");
					return false;
				}
				this.isShow = true;
			},
			sendPhone() {
				this.$request({
					url: this.$api.boss.sendPhone,
					data: {
						phone: this.form.phone
					}
				}).then((res) => {
					if (res.data.success) {
						this.$message.success("发送成功");
					} else {
						this.$message.error("发送失败");
					}
				})
			},
			prev() {
				this.studentPage--;
				if (this.studentPage < 1) {
					this.studentPage = 1;
					this.$message.info("没有更多了~");
				} else {
					this.queryStudentList();
				}
			},
			next() {
				this.studentPage++;
				if (this.studentPage > this.studentList.pages) {
					this.$message.info("没有更多了~");
					this.studentPage = this.studentList.pages;
				} else {
					this.queryStudentList();
				}
			},
			chooseStudent(item) {
				this.currentStudent = item;
				this.currentStudentImg = [];
				this.currentStudentImg.push(this.filePath + item.studentImage);
				this.showStudentModal = true;
			},
			closeStudentModal() {
				this.showStudentModal = false;
			},
			changeAddress(data) {
				this.currentAddress = data;
				this.studentList = [];
				this.currentStudent = {};
				this.studentPage = 1;
				this.queryStudentList();
			},
			//获取学员地址列表
			quryAddressList() {
				this.$request({
					url: this.$api.boss.quryAddressList,
				}).then((res) => {
					this.addressList = res.data.result;
					this.currentAddress = this.addressList[0];
					this.queryStudentList();
				})
			},
			//获取学员列表
			queryStudentList() {
				this.$request({
					url: this.$api.boss.queryStudentList,
					data: {
						addressId: this.currentAddress.id,
						pageNo: this.studentPage,
						pageSize: 6
					}
				}).then((res) => {
					this.studentList = res.data.result;
				})
			},
			closeModal() {
				this.showModal = false;
			},
			getNewArray(array, subGroupLength) {
				let index = 0;
				let newArray = [];
				while (index < array.length) {
					newArray.push(array.slice(index, index += subGroupLength));
				}
				return newArray;
			},
			chooseMeet(item) {
				console.log(item);
				this.currentMeeting = item;
				let _banner = this.currentMeeting.bannerUrl;
				let _newBanner = [];
				_banner.forEach((item) => {
					item = this.filePath + item;
					_newBanner.push(item);
				})
				this.currentBanner = _newBanner;
				this.showModal = true;
				console.log(this.currentMeeting);
			},
			//轮播图
			queryBossBannerList() {
				this.$request({
					url: this.$api.boss.queryBossBannerList,
				}).then((res) => {
					this.bannerList = res.data.result;
				})
			},
			//早会数据
			queryMettingList() {
				let that = this;
				this.$request({
					url: this.$api.boss.queryMettingList,
				}).then((res) => {
					let _list = res.data.result;
					this.width = {
						width: (_list.length * 290) + "px"
					};
					this.showMeeting = true;
					_list.forEach((item) => {
						item.bannerUrl = item.bannerUrl.split(",");
						that.meetingList.push(item)
					})
					that.meetingList = that.getNewArray(this.meetingList, 4);
					console.log(that.meetingList);
				})
			},
			//boss数据
			queryBossData() {
				this.$request({
					url: this.$api.boss.queryBossData
				}).then((res) => {
					this.bossData = res.data.result;
				})
			},
		}
	}
</script>

<style scoped>
	.apply {
		width: 70px;
		height: 70px;
		background-color: #34a8ff;
		color: white;
		position: fixed;
		bottom: 30px;
		right: 30px;
		display: flex;
		flex-flow: column nowrap;
		justify-content: center;
		align-items: center;
		border-radius: 4px;
		font-size: 16px;
		font-weight: bold;
		cursor: pointer;
	}

	.meeting {
		overflow: hidden;
	}

	.meeting .title {
		font-size: 30px;
		font-weight: bold;
		padding-top: 40px;
		text-align: center;
		color: #1a1a1a;
	}

	.meeting .sub_title {
		text-align: center;
	}

	.meeting .box {
		margin-top: 50px;
		width: 1200px;
		height: 400px;
		display: flex;
		justify-content: space-around;
	}

	.meeting .box .item {
		width: 260px;
		height: 400px;
		position: relative;
		transition: all 0.3s;
		z-index: 999;
		cursor: pointer;
		margin-left: 30px;
	}

	.meeting .box .item:hover {
		transform: scale(1.06);
	}

	.info_btn {
		width: 160px;
		height: 40px;
		background-color: #34a8ff;
		color: white;
		border-radius: 8px;
		position: absolute;
		bottom: 30px;
		border: none;
		left: 50px;
	}

	.data-box {
		height: 220px;
		display: flex;
		justify-content: space-around;
		align-items: center;
		background: url(../../assets/boss/data_bg.png);
	}

	.data-box .item {
		position: relative;
		text-align: center;
	}

	.data-box .item .number {
		font-size: 26px;
		font-weight: bold;
		color: white;
	}

	.data-box .item .title {
		color: white;
	}

	.fengcai {}

	.fengcai .control {
		padding: 30px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.fengcai .control .change {
		display: flex;
		align-items: center;
	}

	.fengcai .control .change .prev {
		width: 30px;
		height: 30px;
		border-radius: 30px;
		border: none;
		margin-right: 5px;
		cursor: pointer;
	}

	.fengcai .control .change .next {
		width: 30px;
		height: 30px;
		border-radius: 30px;
		border: none;
		cursor: pointer;
	}

	.fengcai .control .tabs {
		display: flex;
		align-items: center;
	}

	.fengcai .control .tabs .tab {
		margin-right: 15px;
		cursor: pointer;
	}

	.fengcai .control .tabs .active {
		background-color: #34a8ff;
		padding: 5px 10px;
		color: white;
		border-radius: 30px;
	}

	.fengcai .title {
		font-size: 30px;
		font-weight: bold;
		padding-top: 40px;
		text-align: center;
		color: #1a1a1a;
	}


	.fengcai .list {
		display: flex;
		flex-flow: row wrap;
		padding: 15px;
	}

	.fengcai .list .item {
		width: 360px;
		height: 360px;
		background-color: #34a8ff;
		margin-left: 22px;
		margin-bottom: 20px;
		border-radius: 8px;
		position: relative;
		cursor: pointer;
	}


	.fengcai .list .item .color-mask {
		width: 100%;
		height: 100%;
		top: 0;
		position: absolute;
	}

	.fengcai .list .item .color-mask .name {
		padding: 20px;
		color: white;
		font-size: 20px;
		font-weight: bold;
		padding-bottom: 10px;
	}

	.fengcai .list .item .color-mask .position {
		color: white;
		font-weight: bold;
		padding-left: 30px;
		font-size: 18px;
		position: absolute;
		bottom: 20px;
		right: 20px;
		/* margin:20px; */
	}

	.fengcai .list .item .color-mask .desc {
		color: white;
		padding-left: 20px;
		padding-right: 20px;
		position: absolute;
		top: 180px;
		text-indent: 0.5cm;
	}

	.fengcai .list .item .mask-0 {
		background-image: linear-gradient(rgba(255, 180, 0, 0) 0%, rgb(0, 195, 151) 100%);
		border-radius: 8px;
	}

	.fengcai .list .item .mask-1 {
		background-image: linear-gradient(rgba(224, 35, 26, 0) 0%, rgb(255, 95, 0) 100%);
		border-radius: 8px;
	}

	.fengcai .list .item .mask-2 {
		background-image: linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(143, 53, 255) 100%);
		border-radius: 8px;
	}

	.fengcai .list .item .mask-3 {
		background-image: linear-gradient(rgba(255, 180, 0, 0) 0%, rgb(0, 255, 151) 100%);
		border-radius: 8px;
	}

	.fengcai .list .item .mask-4 {
		background-image: linear-gradient(rgba(255, 180, 0, 0) 0%, rgb(255, 80, 150) 100%);
		border-radius: 8px;
	}

	.fengcai .list .item .mask-5 {
		background-image: linear-gradient(rgba(255, 180, 0, 0) 0%, rgb(0, 100, 250) 100%);
		border-radius: 8px;
	}

	.fengcai .list .item .thumb {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 8px;
	}

	.idea {
		background-color: #f5f5f5;
	}

	.idea .title {
		font-size: 30px;
		font-weight: bold;
		padding-top: 40px;
		text-align: center;
		color: #1a1a1a;
	}

	.idea .sub_title {
		font-size: 15px;
		text-align: center;
	}

	.idea-item {
		display: flex;
		flex-flow: row wrap;
		justify-content: center;
		padding: 50px;
	}

	.idea-item .item {
		width: 500px;
		padding-bottom: 30px;
		padding-left: 50px;
		padding-right: 50px;
		display: flex;
		position: relative;
	}

	.idea-item .item .item-title {
		font-size: 20px;
		font-weight: bold;
	}

	.idea-item .item .item-desc {
		margin-top: 5px;
	}

	.idea-item .item img {
		width: 80px;
		height: 80px;
	}

	.bg {
		width: 100%;
		height: 1000px;
		background: url("../../assets/boss/head_bg.jpg");
		background-size: 100%;
		background-repeat: no-repeat;
	}

	.content {
		position: relative;
		width: 1200px;
		margin-top: -600px;
		padding-bottom: 40px;
		background-color: white;
		margin-left: auto;
		margin-right: auto;
	}

	.title-box {
		text-align: center;
	}

	.title-box .img {
		position: relative;
		z-index: -1;
	}

	.title-box .title {
		position: absolute;
		z-index: 99;
		top: 8px;
		color: white;
		font-size: 26px;
		left: 550px;
		font-weight: bold;
	}

	.news {
		display: flex;
		justify-content: space-between;
	}

	.news .news-content {
		width: 600px;
		height: 344px;
		background-color: #35a8ff;
		padding: 15px;
		font-size: 16px;
	}

	.news .news-content p {
		text-indent: 1cm;
		color: white;
		word-spacing: 2px;
		line-height: 26px;
	}

	.news .banner {
		width: 600px;
		height: 344px;
	}

	.news .banner img {
		width: 100%;
		height: 100%;
	}

	.vue-puzzle-vcode{
		z-index: 9999;
	}
</style>



// WEBPACK FOOTER //
// src/pages/boss/index.vue